import axios from 'axios'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  getSubscription({ commit, state }) {
    // return mockResponse
    return axios
      .get(`/consumer-api/dashboard/v1/view`)
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        // Reject the promise is required to trigger error on response
        return Promise.reject(error.response.data.message)
      })
  },

  setOwnership({ commit, state }, id) {
    return (
      axios
        // path is 'consumer-api
        .patch(`/api/v1/subscription/ownership/${id.id}`)
        .then((response) => {
          return response.data
        })
        .catch((error) => {
          // Reject the promise is required to trigger error on response
          return Promise.reject(error.response.data.message)
        })
    )
  },
}
//
// const mockResponse = {
//   active: true,
//   daysRemaining: 2,
//   reportsAvailable: 325,
//   expirationDate: '2019-02-14T19:19:27+00:00',
//   lastReport: {
//     vehicle: '2014 Honda Accord EX-L',
//     vin: '1HGCR2F85EA082578',
//     accidentRecord: false,
//     singleOwner: false,
//     buybackProtection: 'THREE_YEARS',
//     recordCount: 12,
//     score: 95,
//     scoreRangeLow: 47,
//     scoreRangeHigh: 72,
//     searchDate: '2019-02-14T19:19:27+00:00',
//     imageClass: 'Mid-Sized',
//   },
//   allReports: [
//     {
//       id: 1,
//       vehicle: '2012 Audi A7 Quattro Prestige',
//       vin: 'WAU2GAFC7CN085211',
//       score: 86,
//       accidentRecord: true,
//       singleOwner: false,
//       buybackProtection: 'THREE_YEARS',
//       searchDate: '2019-02-14T19:19:27+00:00',
//       dateExpires: '2019-02-14T19:19:27+00:00',
//       own: false,
//       active: true,
//     },
//     {
//       id: 2,
//       vehicle: '2014 Honda Accord EX-L',
//       vin: '1HGCR2F85EA082578',
//       score: 95,
//       accidentRecord: false,
//       singleOwner: true,
//       buybackProtection: 'NOT_ASSURED',
//       searchDate: '2019-02-14T19:19:27+00:00',
//       dateExpires: '2019-02-14T19:19:27+00:00',
//       own: true,
//       active: false,
//     },
//   ],
// }
